import style from './index.module.scss';
import {Button, Form, Input, message, Tooltip} from 'antd';
import {errorMessage} from 'Utils/common';
import useRequestFn from 'Utils/Hooks/useRequestFn';
import classNames from 'classnames';
import {useMount, useUpdate} from 'react-use';
import {useForm} from 'antd/es/form/Form';
import login from 'Services/auth';
import Storage from 'Services/Storage';
import {LinkButton} from '../../../Features/Buttons/LinkButton';
import useModalHandler from '../../../Utils/Hooks/useModalHandler';
import {ForgetModal} from './Components/ForgetModal';
import logoImg from './img/logo.png';

interface FormData {
    loginName: string;
    password: string;
}

const initialValues: FormData =
    process.env.NODE_ENV === 'production'
        ? {loginName: '', password: ''}
        : {loginName: 'admin', password: 'esG$MjLC'};

export default function Login() {
    const [form] = useForm();
    const forgetModal = useModalHandler();

    const [doLogin, {loading}] = useRequestFn(async (data: FormData) => {
        try {
            await login(data.loginName, data.password);
            window.location.replace('/');
        } catch (e) {
            message.error(errorMessage(e, '登录失败'));
        }
    });

    const update = useUpdate();
    const userError = form.getFieldError('loginName')?.[0];
    const passError = form.getFieldError('password')?.[0];

    useMount(() => {
        Storage.clear();
    });

    return (
        <div className={style.root}>
            <div className={style.main}>
                <div className={style.left}>
                    <img src={logoImg} alt="" className={style.logo} />
                    <h1>校友SaaS后台管理系统</h1>
                    <p>SaaS Management System</p>
                </div>
                <div className={style.form}>
                    <div className={style.loginInfo}>
                        <h1>欢迎登陆</h1>
                        <p>Login you account</p>
                    </div>
                    <Form
                        className={style.formBox}
                        form={form}
                        autoComplete="off"
                        onFinish={doLogin}
                        onFinishFailed={update}
                        onValuesChange={update}
                        initialValues={initialValues}>
                        <div className={style.field}>
                            <div className={style.label}>
                                账号
                                <span className={style.labelEn}>Username</span>
                            </div>

                            <Tooltip
                                title={userError}
                                color="red"
                                placement="right"
                                open={!!userError}>
                                <Form.Item
                                    name="loginName"
                                    noStyle
                                    rules={[
                                        {
                                            required: true,
                                            message: '请输入用户名',
                                        },
                                    ]}>
                                    <Input
                                        prefix
                                        placeholder="请输入用户名"
                                        className={classNames(
                                            style.input,
                                            style.inputUser,
                                        )}
                                        maxLength={100}
                                    />
                                </Form.Item>
                            </Tooltip>
                        </div>

                        <div className={style.field}>
                            <div className={style.label}>
                                密码{' '}
                                <span className={style.labelEn}>Password</span>
                            </div>

                            <Tooltip
                                title={passError}
                                color="red"
                                placement="right"
                                open={!!passError}>
                                <Form.Item
                                    name="password"
                                    noStyle
                                    rules={[
                                        {required: true, message: '请输入密码'},
                                    ]}>
                                    <Input.Password
                                        prefix
                                        placeholder="请输入密码"
                                        className={classNames(
                                            style.input,
                                            style.inputPass,
                                        )}
                                        maxLength={100}
                                    />
                                </Form.Item>
                            </Tooltip>
                        </div>

                        <div className={style.links}>
                            <LinkButton
                                className={style.btnForget}
                                onClick={() => forgetModal.open()}>
                                忘记密码
                            </LinkButton>
                        </div>

                        <Form.Item noStyle>
                            <Button
                                style={{marginTop: 40}}
                                size="large"
                                block
                                type="primary"
                                htmlType="submit"
                                loading={loading}>
                                登录
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>

            {forgetModal.render(<ForgetModal />)}
        </div>
    );
}
